import type { ICountryModel } from '$shared/interfaces/api/ICountryModel';
import BaseModel from './BaseModel';

export class CountryModel extends BaseModel<ICountryModel> {
  public get id(): string {
    return this.response?.id;
  }

  public get name(): string {
    return this.response?.name || '';
  }

  public get isoCode(): string {
    return this.response?.isoCode || '';
  }

  public toCommonList(): CommonList {
    return {
      id: this.id,
      label: this.name
    };
  }
}
